// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import React from 'react';
import { useAppDispatch, useAppSelector } from 'Hooks';
import { Box, useTheme } from '@mui/system';
import { Grid } from '@mui/material';
import SearchField from 'Components/SearchField';
import stylesDef from './styles';
import ProjectsMapToggle from '../ProjectsMapToggle';
import { SetKeywordFilterAction } from '../projectListActions';

type PageToolbarProps = {
  showMapview: boolean;
  showMapviewClick: () => void;
  showGridviewClick: () => void;
};

// AUT-6432: the search row from the Figma dashboard - a full-width search pill with the
// Projects / Map switch beside it. Sorting, filtering and the list/cards switch live in
// ProjectsSubheader, directly above the projects they act on.
const PageToolbar = ({ showMapview, showMapviewClick, showGridviewClick }: PageToolbarProps) => {
  const theme = useTheme();
  const styles = stylesDef(theme, showMapview);
  const dispatch = useAppDispatch();
  const { keywordFilter } = useAppSelector((state) => state.projectList);

  return (
    <Box sx={styles.pageToolbar}>
      <Grid sx={styles.pageToolbarContainer}>
        {/* Search is the server's to apply, so changing it is just a state change here -
            useDashboardProjects refetches the set the new keyword describes. */}
        <SearchField
          value={keywordFilter}
          placeholder="Search by projects or folders..."
          sx={styles.searchField}
          onChange={(value: string) => {
            dispatch(SetKeywordFilterAction(value));
          }}
        />
        <ProjectsMapToggle
          value={showMapview ? 'map' : 'projects'}
          onChange={(view) => (view === 'map' ? showMapviewClick() : showGridviewClick())}
        />
      </Grid>
    </Box>
  );
};

export default PageToolbar;
